import { render, staticRenderFns } from "./WeatherAlerts.html?vue&type=template&id=16e1f97e&scoped=true&external"
import script from "./WeatherAlerts.vue?vue&type=script&lang=js"
export * from "./WeatherAlerts.vue?vue&type=script&lang=js"
import style0 from "./WeatherAlerts.scss?vue&type=style&index=0&id=16e1f97e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e1f97e",
  null
  
)

export default component.exports